<template>
  <welfare-detail is-create />
</template>

<script>
import WelfareDetail from './detail'
export default {
  name: 'CreateWelfare',
  components: { WelfareDetail }
}
</script>
